import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Radio,
  FormControlLabel,
  RadioGroup,
  Typography,
  Box,
  TextField,
  Button,
  Divider,
  Dialog,
  DialogContent,
  Checkbox,
  Menu,
  MenuItem,
} from "@mui/material";
import { UseMotorRouting } from "./UseMotorRouting";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import MapRoutes from "./MapRoutes";
import "leaflet/dist/leaflet.css";
import { MapContainer } from "react-leaflet";
import ChangeLocation from "./ChangeLocation";
import OrderDetailsLog from "./OrderDetailsLog";
import { useSnackbar } from "notistack";
import AllRoutsLists from "./AllRoutsLists";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function AllMapContainer(props) {
  const { isSmall } = useBreakpoints();

  return (
    <Box sx={{ height: "100%" }} gridColumn={isSmall ? "span 12" : "span 10"}>
      <Box
        sx={{
          borderBottom: "1px solid #cdcdcd",
          display: "flex",
          alignItems: "center",
          justifyContent: isSmall ? "space-between" : "flex-end",
          bgcolor: "#000000",
        }}
      >
        <Typography
          sx={{
            borderLeft: "1px solid #cdcdcd",
            p: 1,
            px: 2,
            width: isSmall ? "50%" : "20%",
            textAlign: "center",
            color: "#fff",
          }}
          variant="subtitle1"
        >
          روت : {props.routes ? props.routes.length + " " : "-"}
          عدد
        </Typography>
        <Typography
          sx={{
            borderLeft: "1px solid #cdcdcd",
            p: 1,
            px: 2,
            color: "#fff",
            width: isSmall ? "50%" : "20%",
            textAlign: "center",
          }}
          variant="subtitle1"
        >
          سفارش :{" "}
          {props.locations && props.locations.length
            ? props.locations.length + "  عدد"
            : "-"}
        </Typography>
      </Box>

      {props.open.show ? (
        <Dialog
          sx={{ "& .MuiDialog-paper": { zIndex: 10000 } }}
          PaperProps={{
            elevation: 1,
          }}
          // sx={{ zIndex: 10000 }}
          fullWidth
          maxWidth="md"
          open={props.open.show}
          onClose={() => props.setOpen({ ...props.open, show: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <MapContainer
              center={[
                props.open?.model?.latitude
                  ? props.open.model.latitude
                  : 35.7009,
                props.open?.model?.longitude
                  ? props.open.model.longitude
                  : 51.391241,
              ]}
              // center={center}
              zoom={11}
              style={{
                height: "350px",
                width: "100%",
                display: "flex",
                flex: 1,
              }}
            >
              <ChangeLocation
                sendNewLoc={props.sendNewLoc}
                setSendNewLoc={props.setSendNewLoc}
                myLocations={props.open?.model ?? [35.7009, 51.391241]}
                open={props.open}
                setOpen={props.setOpen}
              />
            </MapContainer>
            <OrderDetailsLog
              zoneIndex={props.zoneIndex}
              sendNewLoc={props.sendNewLoc}
              setSendNewLoc={props.setSendNewLoc}
              open={props.open}
              setOpen={props.setOpen}
              callback={() => {
                props.setOpen({ ...props.open, show: false });
                props.setChangeZoom(true);
                props.refreshAllPage();
              }}
            />
          </DialogContent>
        </Dialog>
      ) : (
        <MapContainer
          center={[35.7009, 51.391241]}
          // center={center}
          zoom={11}
          style={{
            height: isSmall ? "20rem" : "92%",
            width: "100%",
          }}
        >
          <MapRoutes
            isSearch={props.isSearch}
            setLocationRout={props.setLocationRout}
            locationRout={props.locationRout}
            routes={props.routes ?? ""}
            locations={props.locations ?? [35.7009, 51.391241]}
            open={props.open}
            setOpen={props.setOpen}
            setOrderDetail={props.setOrderDetail}
            setOrderModel={props.setOrderModel}
            orderModel={props.orderModel}
            changeZoom={props.changeZoom}
            setChangeZoom={props.setChangeZoom}
            setZoneIndex={props.setZoneIndex}
          />
        </MapContainer>
      )}
      {/* {open.show && (
               
              )} */}
    </Box>
  );
}
